(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  document.querySelector('.back-to-browse-button').addEventListener('click', function() {
    // 直前のページの URL を取得
    const previousPage = document.referrer;
    
    // 直前のページが "/cart" の場合は "/pages/category" にリダイレクト
    if (previousPage.includes('/cart')) {
      window.location.href = '/pages/category';
    } else {
      // ブラウザの履歴を1つ戻る
      window.history.back();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
      
  var goTopBtn = document.querySelector('.js-scroll-top');
  goTopBtn.addEventListener("click", function(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
